export class Constants {
    static routes: Array<string> = [
        "About",
        "Services",
        //"Works",
        "Contact",
    ]
}